export default __webpack_public_path__ + "static/ai_icon-57a2df34bd0584c988127dd896ef558a.png";